var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-full fixed h-full flex justify-center items-center mdmax:relative bg-white"
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "w-7/12 bg-white h-full"
  }, [_c('div', {
    staticClass: "polygon bg-neutral-600 h-full flex items-start flex-col justify-center gap-10 pl-20"
  }, [_c('p', {
    staticClass: "text-4xl font-bold text-white"
  }, [_vm._v("6 Keuntungan Bergabung Dengan linknau")]), _c('div', {
    staticClass: "w-10/12"
  }, [_c('div', {
    staticClass: "flex gap-6 mb-10 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 flex items-start gap-6"
  }, [_c('span', {
    staticClass: "text-primary-500"
  }, [_c('Currency', {
    attrs: {
      "width": "48",
      "height": "48"
    }
  })], 1), _vm._m(0)]), _c('div', {
    staticClass: "flex-1 flex items-start gap-6"
  }, [_c('span', {
    staticClass: "text-primary-500"
  }, [_c('Courier', {
    attrs: {
      "width": "48",
      "height": "48"
    }
  })], 1), _vm._m(1)])]), _c('div', {
    staticClass: "flex gap-6 mb-10 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 flex items-start gap-6"
  }, [_c('span', {
    staticClass: "text-primary-500"
  }, [_c('Discount', {
    attrs: {
      "width": "48",
      "height": "48"
    }
  })], 1), _vm._m(2)]), _c('div', {
    staticClass: "flex-1 flex items-start gap-6"
  }, [_c('span', {
    staticClass: "text-primary-500"
  }, [_c('Grid', {
    attrs: {
      "width": "48",
      "height": "48"
    }
  })], 1), _vm._m(3)])]), _c('div', {
    staticClass: "flex gap-6 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 flex items-start gap-6"
  }, [_c('span', {
    staticClass: "text-primary-500"
  }, [_c('Integration', {
    attrs: {
      "width": "48",
      "height": "48"
    }
  })], 1), _vm._m(4)]), _c('div', {
    staticClass: "flex-1 flex items-start gap-6"
  }, [_c('span', {
    staticClass: "text-primary-500"
  }, [_c('Truck', {
    attrs: {
      "width": "48",
      "height": "48"
    }
  })], 1), _vm._m(5)])])])])]) : _vm._e(), _c('div', {
    staticClass: "w-5/12 bg-white relative h-full mdmax:w-full overflow-y-auto"
  }, [!_vm.isRegistrationSuccess ? _c('div', {
    staticClass: "px-24 py-20 flex flex-col justify-center h-full mdmax:px-10 mdmax:py-10"
  }, [_vm._m(6), _c('div', {
    staticClass: "form text-left"
  }, [_c('h2', {
    staticClass: "text-2xl font-bold text-neutral-800 mb-2"
  }, [_vm._v("Daftar Mitra Baru")]), _c('p', {
    staticClass: "text-neutral-500 mb-8"
  }, [_vm._v(" Lengkapi data di bawah untuk memulai kemitraan. ")]), _c('div', {
    staticClass: "space-y-6"
  }, [_c('TextField', {
    attrs: {
      "label": "Nama Perusahaan",
      "placeholder": "Masukkan Nama Perusahaan",
      "required": true,
      "error": _vm.errors.business_name
    },
    model: {
      value: _vm.payload.business_name,
      callback: function callback($$v) {
        _vm.$set(_vm.payload, "business_name", $$v);
      },
      expression: "payload.business_name"
    }
  }), _c('TextField', {
    attrs: {
      "label": "Nama Admin Pengirim",
      "placeholder": "Masukan Nama Admin",
      "required": true,
      "error": _vm.errors.sender_name
    },
    model: {
      value: _vm.payload.sender_name,
      callback: function callback($$v) {
        _vm.$set(_vm.payload, "sender_name", $$v);
      },
      expression: "payload.sender_name"
    }
  }), _c('TextField', {
    attrs: {
      "label": "Email",
      "placeholder": "Masukan Email",
      "required": true,
      "error": _vm.errors.email
    },
    model: {
      value: _vm.payload.email,
      callback: function callback($$v) {
        _vm.$set(_vm.payload, "email", $$v);
      },
      expression: "payload.email"
    }
  }), _c('TextField', {
    attrs: {
      "type": "number",
      "label": "No. Handphone",
      "placeholder": "Masukan No Handphone",
      "required": true,
      "error": _vm.errors.sender_phone
    },
    model: {
      value: _vm.payload.sender_phone,
      callback: function callback($$v) {
        _vm.$set(_vm.payload, "sender_phone", $$v);
      },
      expression: "payload.sender_phone"
    }
  })], 1), _c('div', {
    staticClass: "w-full mt-10"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Kirim Pendaftaran",
      "size": "full",
      "disabled": !_vm.isValid
    },
    on: {
      "action": _vm.submit
    }
  })], 1)])]) : [_c('div', {
    staticClass: "h-full w-full flex flex-col justify-center items-center px-10 text-center"
  }, [_c('Send', {
    attrs: {
      "width": "120",
      "height": "120"
    }
  }), _c('h2', {
    staticClass: "mt-8 mb-4 text-3xl font-bold text-neutral-800"
  }, [_vm._v(" Cek Email Anda ")]), _c('p', {
    staticClass: "text-neutral-600 mb-10 leading-relaxed"
  }, [_vm._v(" Link verifikasi telah dikirim ke "), _c('br'), _c('b', {
    staticClass: "text-neutral-800"
  }, [_vm._v(_vm._s(_vm.payload.email))])]), _c('Button', {
    attrs: {
      "buttonText": "Kembali Ke Login"
    },
    on: {
      "action": _vm.goToLogin
    }
  })], 1)]], 2), _c('Toast')], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-left text-white"
  }, [_c('p', {
    staticClass: "text-2xl font-bold mb-3"
  }, [_vm._v("Cashback")]), _c('p', {
    staticClass: "text-neutral-400 text-sm"
  }, [_vm._v(" Selain diskon harga, kamu juga akan mendapatkan tambahan cashback jutaan rupiah. ")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-left text-white"
  }, [_c('p', {
    staticClass: "text-2xl font-bold mb-3"
  }, [_vm._v("Kurir Toko")]), _c('p', {
    staticClass: "text-neutral-400 text-sm"
  }, [_vm._v(" Sekarang kamu bisa memiliki Kurir Toko sendiri dengan dukungan multiple logistik. ")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-left text-white"
  }, [_c('p', {
    staticClass: "text-2xl font-bold mb-3"
  }, [_vm._v("Variasi Promo")]), _c('p', {
    staticClass: "text-neutral-400 text-sm"
  }, [_vm._v(" Dapatkan variasi promo lebih banyak dengan menjadi mitra Linknau for Business. ")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-left text-white"
  }, [_c('p', {
    staticClass: "text-2xl font-bold mb-3"
  }, [_vm._v("Akses Khusus")]), _c('p', {
    staticClass: "text-neutral-400 text-sm"
  }, [_vm._v(" Linknau menyediakan akses khusus kepada setiap mitra melalui sistem antarmuka tersendiri. ")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-left text-white"
  }, [_c('p', {
    staticClass: "text-2xl font-bold mb-3"
  }, [_vm._v("Kemudahan Integrasi")]), _c('p', {
    staticClass: "text-neutral-400 text-sm"
  }, [_vm._v(" Sudah punya sistemnya? Kita masih bisa sinergi melalui API. ")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-left text-white"
  }, [_c('p', {
    staticClass: "text-2xl font-bold mb-3"
  }, [_vm._v("Logistik Terlengkap")]), _c('p', {
    staticClass: "text-neutral-400 text-sm"
  }, [_vm._v(" Linknau menyediakan lebih banyak pilihan mitra pengiriman. ")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center mb-12"
  }, [_c('img', {
    staticClass: "inline-block w-48",
    attrs: {
      "src": require("@/assets/images/logos/logo-color.png")
    }
  })]);
}]

export { render, staticRenderFns }